'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = function () {
    (0, _templates.addTemplates)({
        check: function check(e) {
            return e.value ? '<i class="fa fa-check" aria-hidden="true" style="color: limegreen"></i>' : ' <span>-</span>';
        },
        authors: function authors(e) {
            return e.value ? e.value.map(function (v) {
                return '<a href="' + (0, _config2.default)().url.authorProducts({ id: v.id }) + '" title="' + v.type + '">' + v.name + '</a>';
            }).join(', ') : null;
        },
        authorsWithoutLink: function authorsWithoutLink(e) {
            return e.value ? e.value.map(function (v) {
                return '<span>' + v.name + '</a>';
            }).join(', ') : null;
        },
        amountLimit: function amountLimit(e) {
            return e.value > this.amountAvailableLimit ? this.amountAvailableLimit + '+' : e.value;
        },
        invoiceState: function invoiceState(e) {
            if (e.value === 'Unpaid') {
                return '<div class="unpaid-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_Unpaid + '"/>';
            }
            if (e.value === 'Paid') {
                return '<div class="paid-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_Paid + '"/>';
            }
            return '<div class="new-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_New + '"/>';
        },
        packages: function packages(e) {
            if ((0, _isArray2.default)(e.value)) {
                return e.value.map(function (x) {
                    return createPackageLink(x);
                }).join(e.formatString || '');
            }

            var dto = (0, _assign2.default)({}, (0, _typeof3.default)(e.value) === 'object' ? e.value : {
                trackingNumber: e.value,
                urlTemplate: e.value,
                name: e.value
            });
            return createInvoiceLink(dto);

            //return e.value
            //    ? e.value.map(v => `<a href="#${v}" target="blank">${v}</a>`).join(', ')
            //    : null;
        },
        addToCart: function addToCart(e, productIdProp, preorderProp, customerIdProp) {
            var args = {
                productId: (0, _get3.default)(this, productIdProp || 'productId'),
                tabIndex: e.meta.row + 5000,
                formClass: "add-to-cart-form",
                customerId: (0, _get3.default)(this, customerIdProp || 'customerId'),
                amount: e.value,
                preorder: (0, _get3.default)(this, preorderProp || 'preorder')
            };
            if (args.customerId == _abp2.default.session.customerId) {
                delete args.customerId;
            }
            if (this.canPurchase) {
                return '<div class="products-view-table"><div class="add-shop"\n                    data-component="AddToCart"\n                    data-component-args=\'' + (0, _stringify2.default)(args) + '\'>\n                </div></div>';
            } else {
                return '<span>' + (this.amount || 0) + '</span>';
            }
        },
        chooseCustomer: function chooseCustomer(e) {
            var returnUrl = _querystring2.default.parse(window.location.href).returnUrl;
            if (!returnUrl) returnUrl = "";
            var link = '<a href=\'' + linksoft.url.setCustomer({
                id: this.id,
                returnUrl: returnUrl
            }) + '\'>' + e.value + '</a>';
            return link;
        },
        orderState: function orderState(e, enumType) {
            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            var cssClass = ['x', 'star', 'cog orange', 'gears orange', 'truck green', 'check blue', 'exclamation-triangle yellow'][item.id];
            var stateIcon = '<i class="fa fa-' + cssClass + '" data-toggle="tooltip" data-placement="right" data-original-title="' + item.text + '"></i>';
            if (this.slowDelivery) {
                return stateIcon + '<span class="fa fa-clock-o" data-placement="right" data-toggle="tooltip" data-original-title="' + Resx.App.LongerDelivery + '"></i>';
            }
            return stateIcon;
        },
        orderItemState: function orderItemState(e, enumType) {
            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            var cssClass = ['x', 'asterisk yellow', 'cog orange', 'gears orange', 'truck green', 'check blue', 'exclamation-triangle yellow'][item.id];
            var stateIcon = '<i class="fa fa-' + cssClass + '" data-toggle="tooltip" data-placement="right" data-original-title="' + item.text + '"></i>';
            if (this.slowDelivery) {
                return stateIcon + '<span class="fa fa-clock-o" data-placement="right" data-toggle="tooltip" data-original-title="' + Resx.App.LongerDelivery + '"></i>';
            }
            return stateIcon;
        },
        language: function language(e) {
            return e ? e.reference : '';
        },
        downloadDeliveryNote: function downloadDeliveryNote(e) {
            return '\n        <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.pdfDownloadDeliveryNote(this) + '" target="_blank" title="' + Resx.App.PdfDownload + '"><i class="fa fa-file-pdf-o"></i></a>';
        },
        downloadInvoice: function downloadInvoice(e) {
            return '\n        <a href="' + linksoft.url.userDownloadInvoice(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.downloadInvoice(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.pdfDownloadInvoice(this) + '" target="_blank" title="' + Resx.App.PdfDownload + '"><i class="fa fa-file-pdf-o"></i></a>';
        },
        downloadCreditNote: function downloadCreditNote(e) {
            return '\n        <a href="' + linksoft.url.userDownloadCreditNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.downloadCreditNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.pdfDownloadCreditNote(this) + '" target="_blank" title="' + Resx.App.PdfDownload + '"><i class="fa fa-file-pdf-o"></i></a>';
        },
        downloadUnconfirmedDeliveryNote: function downloadUnconfirmedDeliveryNote(e) {
            return '\n            <div class="checkbox">\n                <input type="checkbox" name="SelectedDeliveryNotes" value="' + e.value + '" id="unconfirmed-delivery-notes-checkbox-' + e.value + '" checked unconfirmed-delivery-notes-checkbox/>\n            <label for="unconfirmed-delivery-notes-checkbox-' + e.value + '"></label>\n            </div>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        downloadUnconfirmableDeliveryNote: function downloadUnconfirmableDeliveryNote(e) {
            return '\n            <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        downloadExcel: function downloadExcel(e, urlName) {
            return '<a href="' + linksoft.url[urlName](this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        download: function download(e, urlName, title) {
            var hasFileName = this.hasFileName;
            if (hasFileName) {
                return '<a invoice-id=' + this.id + ' href="' + linksoft.url[urlName](this) + '" title="' + title + '"><i class="fa fa-download"></i></a>';
            } else {
                return "";
            }
        },
        sendNewsletterCheckbox: function sendNewsletterCheckbox(e) {
            return '<input type="checkbox" ' + (e.value ? "checked=\"checked\"" : "") + ' id="dt-sendnewsletter-' + this.id + '" data-user-sendnewsletter="true" data-userid="' + this.id + '"/>\n                <label for="dt-sendnewsletter-' + this.id + '"></label>';
        },
        minMaxAmountSetting: function minMaxAmountSetting(e) {
            return '<div data-min-max-setting="' + this.productId + '" class="stock-value-wrap nowrap">\n                        <button class="edit-stock-amount btn-green" type="button"><i class="fa fa-save"></i></button>\n                        <input name="minAmount" type="number" value="' + this.minAmount + '" data-value="' + this.minAmount + '" placeholder="min">\n                        &nbsp;-&nbsp;\n                        <input name="maxAmount" type="number" value="' + this.maxAmount + '" data-value="' + this.maxAmount + '" placeholder="max">\n                    </div>';
        },
        salesStats: function salesStats(e) {
            // TODO: localize
            return '<span title="' + Resx.App.In30Days + '">' + e.value.amount1 + '</span>\n                &nbsp;|&nbsp;\n                <span title="' + Resx.App.In60Days + '">' + e.value.amount2 + '</span>\n                &nbsp;|&nbsp;\n                <span title="' + Resx.App.In90Days + '">' + e.value.amount3 + '</span>';
        },
        deliveryMethod: function deliveryMethod(e) {
            return e.value ? '<span class="product-icon product-icon-k product-icon--small" data-toggle="tooltip" data-original-title="Do komise"></span>' : '<span class="product-icon product-icon-f product-icon--small" data-toggle="tooltip" data-original-title="Pouze na fakturu"></span>';
        },
        invoiceLink: function invoiceLink(e, urlName) {
            if ((0, _isArray2.default)(e.value)) {
                return e.value.map(function (x) {
                    return createInvoiceLink(urlName, x);
                }).join(e.formatString || '');
            }

            var args = {};
            if (typeof key === 'string') {
                args.id = this[key];
            }

            var dto = (0, _assign2.default)({}, (0, _typeof3.default)(e.value) === 'object' ? e.value : {
                id: e.value,
                name: e.value,
                hasFileName: e.value
            }, args);
            return createInvoiceLink(urlName, dto);
        },
        singleInvoiceLink: function singleInvoiceLink(e, urlName) {

            var dto = (0, _assign2.default)({}, { id: this.id, name: e.value, hasFileName: this.hasFileName });
            return createInvoiceLink(urlName, dto);
        },
        eanLink: function eanLink(e) {
            return e.value ? '<a href="' + (0, _config2.default)().url.product({ id: this.productId }) + '">' + e.value + '</a>' : '<span>' + e.value + '</span>';
        },
        amountAvailable: function amountAvailable(e) {
            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

            if (typeof e.value === 'number') {
                if (e.value <= 0) return '<span class="amount-zero">0</span>';else if (e.value >= limit && !_abp2.default.auth.isGranted('ProductService.CanSeePreciseAmountAvailable')) {
                    return limit + '+';
                }
            }
            return e.value;
        },
        languageIcon: function languageIcon(e, displayCzechFalgs) {
            var language = null;
            var reference = e ? e.reference : '';
            switch (reference) {
                case "001":
                    if (displayCzechFalgs) {
                        language = "cz";
                    }
                    break;
                case "002":
                    language = "sk";
                    break;
                case "003":
                    language = "pl";
                    break;
                case "004":
                    language = "hu";
                    break;
                case "007":
                    language = "gb";
                    break;
            }
            if (language !== null) {
                return '<span class="product-icon product-icon-lang product-icon--small" data-toggle="tooltip" data-original-title="' + e.value.name + '"\n                        style=\'background-image: url(/Content/images/svg/flags/1x1/' + language + '.svg);\'></span>';
            }
            return '<span/>';
        },
        amountState: function amountState(e) {
            var commission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var cssAmountZero = this.amountOnTheWay === 0 && this.amountForProcessing === 0 && this.commissionAmount === 0;

            var decorateAmount = function decorateAmount(title, amount) {
                var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : cssAmountZero;
                return '<span data-toggle="tooltip"\n                  data-placement="top"\n                  data-original-title="' + title + '">\n                <span' + (warn ? ' class="amount-zero"' : '') + '>\n                    ' + amount + '\n                </span>\n            </span>';
            };
            var amounts = [];
            amounts.push(decorateAmount(Resx.App.ProcessingAmount, this.amountForProcessing));
            amounts.push(decorateAmount(Resx.App.AmountOnTheWay, this.amountOnTheWay));
            if (commission) amounts.push(decorateAmount(Resx.App.ConsignmentStore, this.commissionAmount));

            return '<span class="text-center small text-nowrap">\n                ' + amounts.join('&nbsp;&nbsp;|&nbsp;&nbsp;') + '\n            </span>';
        },
        cancelPreOrderItem: function cancelPreOrderItem(e) {
            if (this.cancelRequest) {
                // cancel was requested at one point
                if (this.cancelAccepted === false) {
                    // in this case the cancel was cancelled :) if the cancel was accepted the item should not appear in the table at all
                    return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="' + Resx.App.Denied + '"></i>';
                }
                // cancel is being processed
                return '<i class="fa fa-cogs" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.App.ProcessingAmount + '"></i>';
            }

            return '<a href="#" class="red" data-cancel-all-order-items="' + this.productId + '" data-cancel-all-order-items-name="' + this.productName + '" data-cancel-all-order-items-customerid="' + this.customerId + '" data-cancel-all-order-items-amount="' + this.amountMissing + '" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.Common.Cancel + '"><i class="fa fa-remove"></i></a>';
        },
        cancelOrderItem: function cancelOrderItem(e) {
            if (this.state === "Processing" && this.cancelRequest == null && this.canCancel === true) {
                var cancelAmount = this.amountToCancel;
                return '<a href="#" class="red" data-cancel-order-item="' + this.id + '" data-cancel-order-item-name="' + this.productName + '" data-cancel-order-item-amount="' + cancelAmount + '" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.Common.Cancel + '"><i class="fa fa-remove"></i></a>';
            } else if (this.state != "Canceled" && !(this.cancelRequest == null) && this.cancelAccepted == null) {
                return '<i class="fa fa-cogs" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.App.ProcessingAmount + '"></i>';
            } else if (this.state === "Canceled" || this.cancelAccepted === true) {
                if (this.cancelResultMessage) {
                    return '<i class="fa fa-check green"></i>&nbsp;&nbsp;<i class="fa fa-info" onclick="abp.message.info(\'' + this.cancelResultMessage + '\', \' \');"></i>';
                } else {
                    return '<i class="fa fa-check green"></i>';
                }
            } else if (this.cancelAccepted === false) {
                if (this.cancelResultMessage) {
                    return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="Zam\xEDtnuto"></i>&nbsp;&nbsp;<i class="fa fa-info" onclick="abp.message.info(\'' + this.cancelResultMessage + '\', \' \');"></i>';
                } else {
                    return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="Zam\xEDtnuto"></i>';
                }
            }
        },
        cancelOrderItemTotalNew: function cancelOrderItemTotalNew(e) {
            var cancelAccepted = !e.data.noCancelRequests && e.data.noCancelAcceptance;
            var anyCancellable = e.data.noCancelRequests && e.data.canCancel;

            return tableTemplates.cancelOrderItemTot(e.data.orderItemState, anyCancellable, e.data.amountToCancel, cancelAccepted, e.data.noCancelAcceptance, e.data.productId, e.data.productName);
        },
        cancelOrderItemTotal: function cancelOrderItemTotal(e) {
            var cancelableItems = jQuery.grep(this.items, function (item, index) {
                return item.cancelRequest == null && item.canCancel === true;
            });
            var cancelInProgressItems = jQuery.grep(this.items, function (item, index) {
                return !(item.cancelRequest == null) && item.cancelAccepted == null;
            });

            var anyInProgress = cancelInProgressItems.length > 0;
            return tableTemplates.cancelOrderItemTot(this.state, cancelableItems.length > 0, this.amountToCancel, anyInProgress, this.cancelAccepted, this.productId, this.productName);
        },
        price: function price(e, priceType) {
            return (0, _linksoftAlbatros.formatPrice)(e.value, priceType);
        },
        deleteButton: function deleteButton(e) {
            return '<a data-control-button-delete="' + e.value + '" data-confirm="' + Resx.Messages.ConfirmDelete + '" data-confirm-title="' + Resx.Messages.ConfirmTitle + '" class="remove" href="#">\n                      <i class="fa fa-remove"></i>\n                      </a>';
        },
        authorsOrderProcessingTotal: function authorsOrderProcessingTotal(e) {
            if (!e.data || !e.data.authorIds) return;

            var authorIds = [].concat((0, _toConsumableArray3.default)(e.data.authorIds.matchAll(/[0-9]+/g))).map(function (nms) {
                return parseInt(nms);
            });
            var authorNames = !e.data.authorNames ? [] : e.data.authorNames.split(",").map(function (an) {
                return an.trim();
            });
            var outputString = "";
            for (var i = 0; i < authorIds.length; i++) {
                var authorName = authorNames.length > i ? authorNames[i] : i.toString();
                outputString += (i > 0 ? ", " : "") + '<a href=\'/Product/Author/' + authorIds[i] + '\'>' + authorName + '<a>';
            }
            return outputString;
        },
        packageDelivered: function packageDelivered(event) {
            var inputId = 'packageDelivered_' + event.data.id;
            var checked = event.data.packageDelivered ? 'checked' : '';
            var cls = 'class="package-delivered-checkbox"';
            var input = '<input ' + checked + ' ' + cls + ' name="' + inputId + '" value="true" id="' + inputId + '" type="checkbox" data-id="' + event.data.id + '" />';
            return '<div class="checkbox">' + input + '<label for="' + inputId + '"></label></div>';
        }
    });

    var tableTemplates = {
        cancelOrderItemTot: function cancelOrderItemTot(state, cancelable, cancelAmount, anyInProgress, cancelAccepted, productId, productName) {
            if (state === "Processing" && cancelable) {
                return '<a href="#" class="red" data-cancel-all-order-items="' + productId + '" data-cancel-all-order-items-name="' + productName + '" data-cancel-all-order-items-amount="' + cancelAmount + '" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.Common.Cancel + '"><i class="fa fa-remove"></i></a>';
            } else if (state !== "Canceled" && anyInProgress) {
                return '<i class="fa fa-cogs" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.App.ProcessingAmount + '"></i>';
            } else if (cancelAccepted === false) {
                return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="' + Resx.App.Denied + '"></i>';
            }
        }
    };

    function createInvoiceLink(urlName, args) {
        var fn = (0, _config2.default)().url[urlName];
        var url = "javascript:void(0)";
        if (typeof fn === 'function') {
            url = fn(args);
        } else {
            _abp2.default.log.error('Function window.linksoft.url.' + urlName + ' is missing.');
        }
        if (args.hasFileName) {
            return '<a invoice-id=' + args.id + ' href="' + url + '">' + args.name + '</a> ';
        } else {
            return '<span>' + args.name + '</span> ';
        }
    }

    function createPackageLink(pack) {
        var url = pack.urlTemplate;
        var trackingNumber = pack.trackingNumber;
        var name = pack.name;
        var link = "";

        if (url) {
            var first = url.substring(0, url.indexOf('{'));
            var second = url.substring(url.indexOf('}') + 1);
            if (second) {
                link = first + trackingNumber + second;
            } else {
                link = first + trackingNumber;
            }
            if (trackingNumber && name) {
                return '<span class="sep"></span><a target="_blank" href="' + link + '">' + name + '</a>';
            } else if (name) {
                return '<span>' + name + '</span>';
            } else {
                return '<span> - </span>';
            }
        } else if (name) {
            return '<span>' + name + '</span>';
        } else {
            return '<span> - </span>';
        }
    }
};

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _templates = require('linksoft/data-tables/templates');

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _querystring = require('linksoft/utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("App", "Messages", "Common");

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/table-templates.js
// module id = 951
// module chunks = 0